import React from "react";
import { Field } from "react-final-form";
import { Dropdown } from "primereact/dropdown";
import { Calendar } from "primereact/calendar";
import { InputText } from "primereact/inputtext";
import { Checkbox } from "primereact/checkbox";
import { InputMask } from "primereact/inputmask";

const formFriendlyPhone = phoneNumber => {
  if (!phoneNumber) {
    return "";
  }
  if (phoneNumber[0] === "1") {
    return phoneNumber.slice(1);
  }
  if (phoneNumber[0] === "+") {
    return phoneNumber.slice(2);
  }
  return phoneNumber;
};

const FormItem = ({ name, label, type = "text", h, extra }) => {
  if (type === "dropdown") {
    return (
      <Field
        name={name}
        required={h?.requiredFields?.includes(name)}
        render={({ input, meta }) => (
          <div className="field">
            <span className="p-float-label">
              <Dropdown
                options={extra?.options}
                id={input.name}
                {...input}
                onFocus={() => h?.handleFocus(name)}
                className={h?.classNames({
                  "p-invalid": h?.isFormFieldValid(meta)
                })}
              />
              <label
                htmlFor={input.name}
                className={h?.classNames({
                  "p-error": h?.isFormFieldValid(meta)
                })}
              >
                {label}
              </label>
            </span>
            {h?.getFormErrorMessage(meta)}
          </div>
        )}
      />
    );
  }

  const preventBlur = input => e => {
    if (e?.target?.name === "dateOfLoss") {
      return () => {};
    } else {
      return input.onBlur;
    }
  };

  if (type === "date") {
    return (
      <Field
        name={name}
        required={h?.requiredFields?.includes(name)}
        render={({ input, meta }) => (
          <div className="field">
            <span className="p-float-label">
              <Calendar
                id={input.name}
                {...input}
                showIcon
                value={
                  extra?.value instanceof Date
                    ? extra.value
                    : input?.value instanceof Date
                    ? input.value
                    : null
                }
                onChange={extra?.onChange || input.onChange}
                onBlur={preventBlur(input)}
                maxDate={extra?.maxDate}
                className={h?.classNames({
                  "p-invalid": h?.isFormFieldValid(meta)
                })}
              />
              <label
                htmlFor={input.name}
                className={h?.classNames({
                  "p-error": h?.isFormFieldValid(meta)
                })}
              >
                {label}
              </label>
            </span>
            {h?.getFormErrorMessage(meta)}
          </div>
        )}
      />
    );
  }

  if (type === "checkbox") {
    return (
      <Field
        name={name}
        type={"checkbox"}
        render={({ input, meta }) => (
          <div className="field">
            <span className="p-float-label">
              <Checkbox
                id={name}
                {...input}
                onFocus={() => h?.handleFocus(name)}
                onChange={e => {
                  input.onChange(e.checked);
                  if (extra?.onChange) {
                    extra.onChange(e);
                  }
                }}
                className={h?.classNames({
                  "p-invalid": h?.isFormFieldValid(meta)
                })}
              />
              <label
                htmlFor={name}
                className={h?.classNames({
                  "checkbox-odometer": true,
                  "p-error": h?.isFormFieldValid(meta)
                })}
              >
                {label}
              </label>
            </span>
            {h?.getFormErrorMessage(meta)}
          </div>
        )}
      />
    );
  }

  if (type === "text") {
    return (
      <Field
        name={name}
        required={h?.requiredFields?.includes(name)}
        render={({ input, meta }) => (
          <div className="field">
            <div className="p-inputgroup flex-1">
              <span className="p-float-label">
                {extra?.addon && (
                  <span className="p-inputgroup-addon">{extra.addon}</span>
                )}
                <InputText
                  id={input.name}
                  {...input}
                  keyfilter={extra?.keyfilter}
                  validateOnly={extra?.validateOnly}
                  onFocus={() => h?.handleFocus(name)}
                  className={h?.classNames({
                    "p-invalid": h?.isFormFieldValid(meta)
                  })}
                  onInput={extra?.onInput}
                  maxLength={50}
                />
                <label
                  htmlFor={input.name}
                  className={h?.classNames({
                    "p-error": h?.isFormFieldValid(meta)
                  })}
                >
                  <span className={extra?.addon && "IconFieldLabel"}>
                    {label}
                  </span>
                </label>
              </span>
            </div>
            {h?.getFormErrorMessage(meta)}
          </div>
        )}
      />
    );
  }
  if (type === "phoneNumber") {
    return (
      <Field
        name={name}
        required={h?.requiredFields?.includes(name)}
        render={({ input, meta }) => (
          <div className="field">
            <div className="p-inputgroup flex-1">
              <span className="p-float-label">
                {extra?.addon && (
                  <span className="p-inputgroup-addon">{extra.addon}</span>
                )}
                <InputMask
                  id={input.name}
                  {...input}
                  value={formFriendlyPhone(input.value)}
                  onFocus={() => h?.handleFocus(name)}
                  className={h?.classNames({
                    "p-invalid": h?.isFormFieldValid(meta)
                  })}
                  onInput={extra?.onInput}
                  mask="(999) 999-9999? x999999"
                />
                <label
                  htmlFor={input.name}
                  className={h?.classNames({
                    "p-error": h?.isFormFieldValid(meta)
                  })}
                >
                  <span className={extra?.addon && "IconFieldLabel"}>
                    {label}
                  </span>
                </label>
              </span>
            </div>
            {h?.getFormErrorMessage(meta)}
          </div>
        )}
      />
    );
  }
};

export default FormItem;
